import { useState, useEffect, useRef } from "react";
import styles from "./SearchBar.module.css"; // Assuming CSS Modules
import { CiSearch } from "react-icons/ci";
import { IoIosClose } from "react-icons/io";

const SearchComponent = ({ onSearch }) => {
  const [isSearchVisible, setSearchVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isSearchVisible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isSearchVisible]);

  useEffect(() => {
    if (onSearch) {
      const timer = setTimeout(() => {
        onSearch(searchTerm);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [searchTerm, onSearch]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchVisible(false);
    if (onSearch) onSearch("");
  };

  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchWrapper}>
        {!isSearchVisible ? (
          <button
            className={styles.searchIcon}
            onClick={() => setSearchVisible(true)}
          >
            <CiSearch style={{ fontSize: "22px", color: "#147dfe" }} />
          </button>
        ) : null}

        <div
          className={`${styles.searchInputContainer} ${
            isSearchVisible ? styles.active : ""
          }`}
        >
          <input
            ref={inputRef}
            type="text"
            placeholder="Search..."
            className={styles.searchInput}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <button className={styles.closeButton} onClick={handleClearSearch}>
            <IoIosClose style={{ fontSize: "22px" }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
